var React = require('react');

function DecStarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 2.42705L9.24364 7.83258L9.07525 8.35081H8.53035H2.84664L7.44485 11.6916L7.88569 12.0119L7.71731 12.5301L5.96095 17.9357L10.5592 14.5949L11 14.2746L11.4408 14.5949L16.0391 17.9357L14.2827 12.5301L14.1143 12.0119L14.5551 11.6916L19.1534 8.35081H13.4697H12.9247L12.7564 7.83258L11 2.42705Z","fill":"#FF2200","stroke":"#0034EB","strokeWidth":"1.5"}));
}

DecStarInline.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = DecStarInline;

DecStarInline.default = DecStarInline;
